import { DEFAULT_LOCALE } from '@core/constants';

export const getters = {
  userSettings: (state) => state.userSettings,
  userLocale: (state) => state.userSettings?.language || DEFAULT_LOCALE || 'es',
};
